import { Component, Input, ViewChild } from "@angular/core";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { VacationBuyKind } from "../../models/enums/VacationBaseBuyKindEnum";
import { VacationBuyInformation } from "../../models/vacation-buy-Information.model";

@Component({
  selector: "vacation-buy-Information-form",
  templateUrl: "./vacation-buy-Information-form.component.html",
  styleUrls: ["./vacation-buy-Information-form.component.scss"],
})
export class VacationBuyInformationFormComponent extends BaseFormComponent<VacationBuyInformation> {
  @Input() gridFilter: GridFilter[] = [];
  public apiName: string = "VacationBuyInformation";
  public label: string = "اصلاح مانده مرخصی";
  public dataList: VacationBuyInformation[];
  @ViewChild("grid") public grid: EditableGridComponent;
  gridColumns: form_control[] = [];
  isRefreshingData: boolean = false;
  DefaultValues: Dictionary = [];
  async ngOnInit() {
    this.areaName = "Payroll";
    this.apiName = "VacationBuyInformation";
    this.dataList = [];
    super.ngOnInit();
    await this.setData();
  }
  setColumnAttribute() {
    this.orignalColumns.forEach((x) => {
      if (x.name === "BaseBuyAmount" || x.name === "VacationRemain" || x.name === "BuyAmount") x.inputMask = "00:00:00";
      if (x.name === "BuyAmount") {
        x.disabled = this.model.VacationBuyKindCode === VacationBuyKind.Group;
      } else if (x.formVisible != true) x.disabled = true;
    });
    this.gridColumns = this.orignalColumns.filter((f) => (!f.areaName || f.areaName === "default") && f.listVisible);
    this.gridColumns.forEach((x) => {
      if (x.name === "BaseBuyAmount" || x.name === "VacationRemain" || x.name === "BuyAmount") {
        x.inputMask = "00:00:00";
      }
      if (x.name === "BuyAmount") {
        x.disabled = this.model.VacationBuyKindCode === VacationBuyKind.Group;
      } else if (x.formVisible != true) x.disabled = true;
      if (x.name === "BaseBuyAmount") {
        x.disabled = this.model.VacationBuyKindCode !== VacationBuyKind.Group;
      }
    });
    if (this.grid) {
      this.grid.columns = this.gridColumns;
      this.grid.setColumnWith();
      this.grid.fitColumns();
    }
  }
  onChanged($event) {
    if ($event && $event?.apiName === "VacationBuyInformation/VacationRemainElement") {
      this.setData();
    }
    if ($event && $event?.apiName === "Lookup" && $event?.data?.Category === "VacationBaseBuyKind") {
      this.model.VacationBaseBuyKindCode = $event.data.Code;
      this.model.VacationBaseBuyKindTitle = $event.data.Title;
      this.setValue("VacationBaseBuyKindCode", this.model.VacationBaseBuyKindCode);
      this.setValue("VacationBaseBuyKindTitle", this.model.VacationBaseBuyKindTitle);
    }
    if ($event && $event?.apiName === "Lookup" && $event?.data?.Category === "VacationBuyKind") {
      this.model.VacationBuyKindCode = $event.data.Code;
      this.model.VacationBuyKindTitle = $event.data.Title;
      this.setValue("VacationBuyKindCode", this.model.VacationBuyKindCode);
      this.setValue("VacationBuyKindTitle", this.model.VacationBuyKindTitle);
      this.setColumnAttribute();
      this.cd.markForCheck();
    }
  }
  async setData() {
    if (this.isRefreshingData === true) return;
    if (!this.formGroup?.get("ElementId")?.value) {
      return;
    }
    if (!this.gridFilter.some((x) => x.Filed === "ElementId"))
      this.gridFilter.push({
        Filed: "ElementId",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.formGroup?.get("ElementId")?.value,
        Logic: "and",
      });
    if (!this.gridFilter.some((x) => x.Filed === "IssueYear"))
      this.gridFilter.push({
        Filed: "IssueYear",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.accountService?.authService?.getHrmPayCurentYearMonth()?.CurentYear,
        Logic: "and",
      });
    if (!this.gridFilter.some((x) => x.Filed === "IssueMonth"))
      this.gridFilter.push({
        Filed: "IssueMonth",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.accountService?.authService?.getHrmPayCurentYearMonth()?.CurentMonth,
        Logic: "and",
      });

    this.isRefreshingData = true;
    await this.httpCommonService
      .create(`${this.apiName}/GetVacationRemain`, this.gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          this.isRefreshingData = false;
          if (data) {
            this.dataList = data as [];
            this.model = this.dataList[0];
            this.setFormGroup(this.model);
            this.formGroup.markAsPristine();
          }
        },
        (error) => {
          this.isRefreshingData = false;
          this.getFailedHelper(error);
        }
      );
  }
  getDeMaskedAmount(amount: string, inputMask: string) {
    if (!amount) return 0;
    if (amount.toString().indexOf("_") > -1) amount = amount.replace(/\_/g, "");
    if (inputMask === "00") {
      return Number(amount) * 440;
    }
    if (inputMask === "000:00") {
      return Number(amount.replace(":", "").substr(0, 3)) * 60 + Number(amount.replace(":", "").substr(3, 2));
    }
    if (inputMask === "00:00:00") {
      return (
        Number(amount.replace(":", "").substr(0, 2)) * 440 +
        Number(amount.replace(":", "").substr(2, 2)) * 60 +
        Number(amount.replace(":", "").substr(5, 2))
      );
    }
    return Number(amount);
  }
  async groupAssignment() {
    if (this.isRefreshingData === true) return;
    if (!this.formGroup?.get("BaseBuyAmount")?.value) {
      this.sts.showDialog("مقدار مبنای بازخرید وارد نشده.", `خطا`);
      return;
    }
    if (!this.formGroup?.get("VacationBaseBuyKindCode")?.value) {
      this.sts.showDialog("مبنای بازخرید انتخاب نشده.", `خطا`);
      return;
    }
    let BaseBuyAmount = this.getDeMaskedAmount(this.formGroup?.get("BaseBuyAmount")?.value, "00:00:00");
    if (!this.gridFilter.some((x) => x.Filed === "ElementId"))
      this.gridFilter.push({
        Filed: "ElementId",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.formGroup?.get("ElementId")?.value,
        Logic: "and",
      });
    if (!this.gridFilter.some((x) => x.Filed === "IssueYear"))
      this.gridFilter.push({
        Filed: "IssueYear",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentYear,
        Logic: "and",
      });
    if (!this.gridFilter.some((x) => x.Filed === "IssueMonth"))
      this.gridFilter.push({
        Filed: "IssueMonth",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth,
        Logic: "and",
      });
    if (!this.gridFilter.some((x) => x.Filed === "VacationBaseBuyKindCode"))
      this.gridFilter.push({
        Filed: "VacationBaseBuyKindCode",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.model.VacationBaseBuyKindCode,
        Logic: "and",
      });
    if (!this.gridFilter.some((x) => x.Filed === "BaseBuyAmount"))
      this.gridFilter.push({ Filed: "BaseBuyAmount", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: BaseBuyAmount, Logic: "and" });
    if (!this.gridFilter.some((x) => x.Filed === "VacationBaseBuyKindId"))
      this.gridFilter.push({
        Filed: "VacationBaseBuyKindId",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.formGroup?.get("VacationBaseBuyKindId")?.value,
        Logic: "and",
      });
    if (!this.gridFilter.some((x) => x.Filed === "VacationBuyKindId"))
      this.gridFilter.push({
        Filed: "VacationBuyKindId",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.formGroup?.get("VacationBuyKindId")?.value,
        Logic: "and",
      });

    this.isRefreshingData = true;
    await this.httpCommonService
      .create(`${this.apiName}/GroupAssignment`, this.gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          this.isRefreshingData = false;
          if (data) {
            this.dataList = data as [];
            this.formGroup.markAsPristine();
          }
        },
        (error) => {
          this.isRefreshingData = false;
          this.getFailedHelper(error);
        }
      );
  }
  async _save(event: VacationBuyInformation) {
    try {
      if (!this.isSaving) {
        if (this.isValid()) {
          this.sts.showToast("info", "", "در حال ذخیره تغییرات...");
          this.isSaving = true;
          this.isSaved = false;
          if (event.Id === undefined || event.Id === 0 || Number.isNaN(event.Id) || event.Id === null) {
            await this.httpCommonService
              .create(this.apiName, event)
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (row) => {},
                (error) => this.saveFailedHelper(error)
              );
          } else {
            await this.httpCommonService
              .update(this.apiName, event)
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (row) => {},
                (error) => this.saveFailedHelper(error)
              );
          }
        } else {
          this.selectorService.submitted$.next(this.submitted);
        }
      } else {
        this.selectorService.submitted$.next(this.submitted);
      }
    } catch (e) {
      this.saveFailedHelper(e);
    }
  }
}
